import { render, staticRenderFns } from "./Form2_Tarjeta_Credito.vue?vue&type=template&id=fb16476a"
import script from "./Form2_Tarjeta_Credito.vue?vue&type=script&lang=js"
export * from "./Form2_Tarjeta_Credito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb16476a')) {
      api.createRecord('fb16476a', component.options)
    } else {
      api.reload('fb16476a', component.options)
    }
    module.hot.accept("./Form2_Tarjeta_Credito.vue?vue&type=template&id=fb16476a", function () {
      api.rerender('fb16476a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios1/OCA/Form2_Tarjeta_Credito.vue"
export default component.exports